<template>
    <body>
        <nav>
            <router-link to="/">ETUSIVU</router-link>
            <router-link to="/conversation">DEMOKESKUSTELU</router-link>
            <router-link to="/">ARVOSTELE</router-link>
            <router-link to="/">OMA SIVU</router-link>
        </nav>
        <div id="container">
        </div>
    <footer>
        <p>TRIGENDADIGI</p>
        <p>demo 1</p>
        <p>OTA YHTEYTTÄ</p>
        <p>email: info@trigenda.fi</p>
    </footer>
    </body>
</template>

<script>

export default {
    name: 'ContactInfo',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
p {
  margin:0.5em;
}
nav {
    display: flex;
    background-color:#444444;
    width:100%;
    position:fixed;
    top:0;
    left:0;
    max-height:25%;
    overflow:hidden;
    z-index: 1;
    justify-content: center;
}
nav > a {
  color:white;
  text-decoration:none;
  padding: 1em 3em;
  margin: 0 1em;
  width: 10em;
}
nav>a:hover {
    background-color: #AEAEAE;
    color: #444444;
}
footer {
  background-color:#444444;
  width:100%;
  color:white;
  margin-top: 3em;
  padding-top: 2em;
  padding-bottom: 2em;
  text-align: left;
}
footer > p {
    margin-left: 23em;
}
body {
  min-height:100%;
  height:100%;
  font-family: "Bahnschrift", Times, serif;
  background: linear-gradient(180deg, rgba(255,255,255,1) 46%, rgba(174,174,174,1) 100%);
  width:100%;
}
#container {
  width:80%;
  display: inline-grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, auto);
  justify-items: center;
  min-height: 100%;
  margin-top: 1em;
  grid-gap: 3em 0;
  text-align: left;
}
#box1 {
    background-color: rgba(77, 205, 213, 0.2);
    box-shadow: 0px 0px 15px #4DCDD5;
}
#box2 {
    background-color: rgba(104, 212, 89, 0.2);
    box-shadow: 0px 0px 15px #68D459;
}
#box3 {
    background-color: rgba(255, 147, 67, 0.2);
    box-shadow: 0px 0px 15px #FF9343;
}
#logo {
    width: 15vw;
    float: right;
    margin-left: 55%;
}
.infoBox {
    clear: none;
    padding: 0 2em;
    width: 70%;
}
.infoBox > h1 {
    font-size: 1.25em;
}
</style>
